<template>
    <ion-page class="ion-page" id="main">
        <default-header>
            <template v-slot:start>
                <ion-buttons slot="start">
                    <header-menu/>
                </ion-buttons>
            </template>
        </default-header>

        <ion-content fullscreen>
            <flash-messages/>

<!--            <div v-if="$store.getters.authed && $store.getters.user.covid_agreement_signed_at === null"-->
<!--                 style="padding: 20px;">-->
<!--                {{ $t('ncrypt.covid_triage.sign_agreement_to_access') }}-->
<!--                <br/>-->
<!--                <br/>-->
<!--                <ion-button @click="$router.push({name: 'covid-agreement-form'})">-->
<!--                    {{ $t('ncrypt.covid_triage.visit_agreement_form_button_text') }}-->
<!--                </ion-button>-->
<!--            </div>-->

            <div v-if="loading" style="margin: 200px 0; display: flex; justify-content: center;">
                <ion-spinner/>
            </div>

            <ion-grid v-else>
                <!--                <ion-row>-->
                <!--                    <ion-col size-xs="12">-->
                <!--                        <ion-card style="margin-bottom: 0; margin-top: 5px;">-->
                <!--                            <ion-card-header>-->
                <!--                                <ion-card-title>{{ $t('ncrypt.covid_triage.dashboard.title') }}</ion-card-title>-->
                <!--                            </ion-card-header>-->
                <!--                            <ion-card-content style="padding-top: 5px;">-->
                <!--                                <ion-text>{{ $t('ncrypt.covid_triage.dashboard.intro') }}</ion-text>-->
                <!--                            </ion-card-content>-->
                <!--                        </ion-card>-->
                <!--                    </ion-col>-->
                <!--                </ion-row>-->

                <ion-row>
                    <ion-col size-xs="12">
                        <ion-card style="margin-bottom: 0; margin-top: 5px;">
                            <ion-card-header>
                                <ion-card-title>
                                    <ion-item class="ion-no-padding ion-no-margin">
                                        <h4 style="margin: 0;">
                                            {{ $t('ncrypt.covid_triage.dashboard.title') }}
                                        </h4>
                                    </ion-item>
                                </ion-card-title>
                            </ion-card-header>
                            <ion-card-content v-if="$store.getters.authed" style="padding-top: 0;">
                                {{ $t('ncrypt.covid_triage.dashboard.content_title') }}
                                <br/>
                                <br/>
                                <ion-button @click="goToTriageForm">
                                    {{ $t('ncrypt.covid_triage.dashboard.go_to_checklist_button_text') }}
                                </ion-button>
                            </ion-card-content>
                        </ion-card>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-content>
    </ion-page>
</template>

<script>
    import FlashMessages from "../../components/ui-elements/FlashMessages";
    import {ApiError} from "@/errors/ApiError";
    import HeaderMenu from "@/components/nav/HeaderMenu";
    import DefaultHeader from "@/components/nav/DefaultHeader";

    export default {
        components: {
            FlashMessages,
            HeaderMenu,
            DefaultHeader,
        },
        name: "CovidTriageForm",
        methods: {
            goToTriageForm() {
                this.$http
                    .post(`/covid-passport/start-triage`)
                    .then(async ({data}) => {
                        if (!data || !data.success) {
                            new ApiError(data, false);
                            return;
                        }

                        await this.$router.push({
                            name: 'covid-triage-form',
                            params: {token: data.token},
                        });
                    })
                    .catch(reason => new ApiError(reason));
            },
        },
    }
</script>
